/**
 * Created by SJ on 12/1/16.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import Global from './modules/global'
import Auth from './modules/auth'
import Home from './modules/home'
import tree from './modules/tree'

Vue.use(Vuex)

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  modules: {
    global: Global,
    auth: Auth,
    home: Home,
    tree: tree
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js